import { Tabs } from 'components/FbUI/Tabs'
import React from 'react'
import { TabKey, useOpportunitiesContext } from './opportunities-context'

type TabsType = {
  key: TabKey
  title: string
  disabled?: boolean
}

const OpportunitiesTabs: React.FC = () => {
  const { setSelectedTab, selectedTag, noKnownRecords } =
    useOpportunitiesContext()

  const tabs: TabsType[] = noKnownRecords
    ? [
        { key: 'custom-companies', title: 'Custom Companies' },
        { key: 'custom-locations', title: 'Custom Locations' },
      ]
    : [
        { key: 'fb-companies', title: 'FB Companies' },
        { key: 'fb-locations', title: 'FB Locations' },
        { key: 'custom-companies', title: 'Custom Companies' },
        { key: 'custom-locations', title: 'Custom Locations' },
      ]

  return (
    <Tabs
      tabs={tabs}
      selectedTab={selectedTag}
      setSelectedTab={(t) => setSelectedTab(t)}
      style={{ borderBottom: 'none' }}
      tabStyle={{ width: '140px' }}
    />
  )
}

export default OpportunitiesTabs
